module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Monday, June 2, 1902,"), _c('br'), _vm._v(" New York City—Before Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA")]), _vm._v(", I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THINK IT’S")])]), _vm._v(" wonderful that you have volunteered to chair the Ladies Citizen Union Funds Committee,” Julia Van Wyck Cahill remarked, handing off her ruby-red velvet mantle to the doorman. Slim, beautiful and elegant, and wearing a very famous ruby pendant that had belonged to a Hapsburg princess, she stood with her daughter in the front hall of their Fifth Avenue home, beaming with pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca, however, was preoccupied. She handed off her own light wrap, a turquoise satin to match her evening gown. “Mama, I did not quite volunteer. I do believe you and Mrs. Astor decided among yourselves to make me cochair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia’s blue eyes widened as she feigned innocent ignorance. “Darling! Whatever makes you say that? My dear, you are the youngest lady to ever chair the committee, and I know you will be superb, Francesca—you always are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In truth, Francesca did not really mind being named the chair, as her current investigation was so routine. A neighbor had realized that certain items in her attics were missing, including several valuable family heirlooms, and having read all about Francesca’s last case in the city’s numerous newspapers, she had requested Francesca’s sleuthing services. Francesca was almost certain that Mrs. Canning’s son-in-law was the thief.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“It is a good cause and someone has to raise funds for the ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("party.” Francesca sighed. “I simply wish you had asked me first if I had the time to give the position all of the effort and attention it deserves.”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Julia took her arm. “I’m sorry, dear. Of course, I should have asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca knew very well what her mother was about. Julia was a great society hostess, and she had been aghast by Francesca’s new profession. Even with Francesca’s success, she remained opposed to her daughter’s involvement in any investigation, although she seemed relieved that Francesca finally had a case that was neither life threatening nor scandalous in nature. Francesca knew her mother wanted her so preoccupied with fundraising for the Citizens Union that she would have time for nothing else other than her fiancé.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the thought of Calder Hart, her heart skipped uncontrollably. But then, Hart had that effect on her, from the time they had first met, when she had refused to admit her attraction to and fascination with such a notorious man. He was one of the city’s wealthiest millionaires, yet he had come from humble beginnings, born out of wedlock on the city’s poverty-stricken Lower East Side. Until recently, in spite of his reputation as a womanizer, he had been considered the greatest catch in town, with almost every socialite vying for his attention for their debutante daughters. Hart, however, preferred to attach himself to infamous courtesans and divorcées, shying away from any serious involvement. Francesca still had to pinch herself from time to time, in order to realize that it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v("—she, Francesca Cahill, who owned an equally notorious reputation as an eccentric, a bluestocking and a sleuth, had somehow snagged Calder Hart. These days, when she walked into a supper party or a ball, knives were sharpened and daggers were drawn behind her back. Once, the whispers and gossip had hurt her feelings; now she rather enjoyed the attention. But then, usually Hart was at her side, whispering in her ear, reminding her to revel in the limelight.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All was not perfect, however. Her father was dead set against Hart. An entire month had gone by since Andrew Cahill had broken off their engagement and he did not seem any closer to coming around, never mind that Francesca’s mother was so angry she refused to speak to him unless it was absolutely necessary. In fact, Julia continued to gloat about the engagement to her society friends, as if it had not been terminated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca had come to realize she could not imagine a future without Hart in it, and she was determined to win Andrew over to their cause. Her father was one of the great progressive thinkers and leaders in the city. He was also a great humanitarian, and Francesca admired him immensely. She could not imagine eloping behind his back, although she and Hart had discussed it. This was the first time in her life that she had not been able to gain her way with her father.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart had suggested they not push Andrew Cahill just now. Calder was out of town right now, and Francesca missed him terribly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if reading her daughter’s mind, Julia said softly, “When will Calder return to the city, Francesca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In a day or two, Mama. He is in Boston, tending to his business affairs.” Hart’s fortune had been amassed through shipping, insurance and the railroads. He was also a world-renowned art collector, with one of the most extensive and valuable privately owned collections in America.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Several months ago, Hart had commissioned her portrait and Francesca had been hugely flattered. The portrait had been a nude, and she had been daring enough to pose for it. Last month, the painting had been completed—and it had also been stolen. With Francesca too upset to think clearly enough to investigate the theft, Hart had put private investigators on the case. But there had been no leads; it was as if the portrait had vanished into thin air. If it ever surfaced publicly, Francesca knew she was finished. ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("She had quite a few enemies, although many of them were now in prison.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca did not want to worry about the missing portrait now. Instead, she thought about her reunion with Hart. She could barely wait to be in his arms, being soundly and thoroughly kissed. “Mama, I am going to bed. It was a pleasant evening,” she said, kissing her cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it was, wasn’t it?” Julia seemed pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Andrew Cahill stepped into the spacious front hall, having been outside giving instructions to the coachman for the next morning. Francesca smiled at her father as he handed off his top hat, white gloves and scarf. Dressed in his tuxedo, he was a short man with a rotund build and excessive side whiskers. “Papa? Did you enjoy the affair tonight?” Her sister, every bit as successful a society hostess as Julia, had held a charity supper to raise funds for the vast new public library, soon to be erected on Fifth Avenue and Forty-Second street. There had been a hundred guests, with champagne, caviar, dinner, dessert and dancing, all in the ballroom of the Waldorf-Astoria Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course I did,” Andrew said, his expression somber. “It is a fine cause and I look forward to the day the library opens. Francesca, I should like to talk to you in the study before you retire for the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca tensed. “Papa, can’t it wait?” she began. She had the dreadful feeling he was going to talk to her about Hart, a subject they had carefully avoided for an entire month. Unless he had changed his mind about them, Francesca did not want to hear whatever her father had to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think we have gone on at great odds for long enough,” he said firmly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Francesca knew that tone. She waited while he kissed Julia’s cheek, bidding her good-night. Then Francesca and Andrew started through the front hall, arm in arm. All of the servants ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("had discreetly vanished, and their heels clicked on the black-and-white marble floors.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I believe Hart is back in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was dismayed. “No, Papa, he is not due back for at least another day, and probably he will not be back until Wednesday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ben Garret saw him this afternoon crossing the street,” Andrew said curtly. And finally he softened. “Or he thought he did. We had lunch and he mentioned your engagement.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no mistaking her father’s intended subject now. They paused on the threshold of his study, a large library with wood-paneled walls; high, pale green ceilings; hundreds of books, most political or philosophical in nature; electric lights; and the family’s single telephone. Beneath the emerald-green marble mantle a small fire crackled in the fireplace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Papa, you broke off our engagement,” Francesca said softly. But she twisted the huge diamond engagement ring which she still wore, refusing to take it off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Andrew regarded her unhappily. “I intended to break it off, but your mother has openly defied me, gleefully telling everyone we meet about your engagement. In private, she won’t even speak to me!” he exclaimed. “And do you think I am blind? I see the ring you continue to wear!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca flushed. “Calder gave me the ring, Papa, and it is a token of his admiration and respect. I simply cannot part with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sighed heavily and walked over to the fireplace, staring down at the flames. “I could tell you stories until I was blue in the face about gullible young women falling for handsome rakes. But like each and every one of those young, naive women, you would not listen to me. You would think you are different, that you are the one to finally capture the cad’s heart.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Francesca went and stood besides him nervously. “Unlike all those other cads, Hart has never suggested that I have captured ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("his heart. But he has told me how much he admires and respects me, how dearly he needs my friendship, and how well he thinks we suit.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you are not marrying for love?” Andrew asked skeptically. “You are marrying for respect, for friendship?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca gave him a look. “I love Calder. I have never been so in love. He has a good side, Papa, one that quite contradicts his selfish reputation. And while he says he does not believe in love, he is very fond of me. I wish you could believe that! I think we suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never said he was not fond of you. I believe he cares for you. Why else would he want to marry you? He hardly needs your money—he is as rich as Hades! But I cannot approve when I know with all of my being that he will hurt you terribly one day. A man like that will eventually stray.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca turned away, trembling. Hart had promised her undying loyalty and fidelity. He claimed he was tired of the life he had thus far led, and while Francesca believed him, she could not help but be afraid that the day might come when his head would be turned by a woman far more beautiful than she was. In fact, such a possibility was her single greatest fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Papa, I hate being at odds with you. I know all of your arguments. We both know he has been a cad when it comes to women—just as you know I am the first woman he has ever asked to marry. Why can’t you give him the benefit of the doubt? If I am making a mistake, isn’t it mine to make?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("He faced her fully and clasped both of her hands. “I am so proud of you. You are so beautiful, so caring and so committed to humanity, Francesca. While I do wish your new profession was not so dangerous, you have saved many lives and brought justice to those who desperately needed it. You and Hart have nothing in common!” he exclaimed. “I understand that he has turned your head, but what about a dozen years from now? You have dedicated your life to easing the pain and the burdens of ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("others less fortunate that yourself. Hart is the most selfish man I know. Passion will not ensure a successful marriage, Francesca, not for the long term.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled away. “That is unfair! You are judging Hart based solely on his reputation. You do not even know him, Papa. He has been nothing but noble to me. If you cast stones at him, Papa, then you cast them at me, too. Please, please trust me now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He appeared ready to weep. “Francesca, you have been too kind and trusting since you were a small child, bringing home stray dogs and cats. I keep thinking that Hart is another stray, a man with no real advocates. Are you certain that you really wish to rescue him this way?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca knew she was Hart’s only genuine friend—he had admitted it. But surely, surely she wasn’t rescuing him as she had all of those strays? If her feelings weren’t love, then Francesca did not know what they could be. “If I am rescuing him, I cannot help my self. Papa, you know that I have never been accepted in society, not until this engagement. Mama’s friends and their daughters always saw me as an eccentric, and they never even tried to make me a part of their circle. Has it ever occurred to you that Hart is rescuing me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Andrew looked at her with surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She held up her hand and the huge diamond there caught the room’s lights and flashed. “It feels so right, Papa, being with him. And not because of passion, but because he has become my dearest and best friend. I am begging you to give him another chance. Please. Because you love me, give Calder one more chance to prove himself to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stared for a long moment. Francesca stood very still, praying he would agree.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“I have treated you as an equal your entire life,” he said slowly. “And even though my heart is telling me not to do so, I surrender. You are a brilliant young woman, and I am hoping that you will come to your senses before it is too late. But until then, I will ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("give Hart another chance—as long as you wait a year before you marry.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A year!” Francesca gasped, her pleasure dissolving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A year,” Andrew returned calmly. “I know that seems like a long time, Francesca, but it is nothing when you think of a commitment made for the rest of your life. If you still feel this way next June, I will give you my blessing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca forced her dismay aside and managed a smile. “Thank you, Papa. Thank you so much.” She hugged him hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tilted up her chin. “I have always been proud of your independent thinking,” he said with a sigh. “I have been wrong to think I could dictate to you after allowing you a lifetime of independence.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She softened. “I am who I am because of you, Papa. I owe you everything.” She kissed his cheek, suddenly lighthearted. If she could control her lustful nature—or convince Hart to take her to bed before they were married—maybe waiting to marry wasn’t such a bad thing. The year would give Andrew enough time to really get to know and like Hart. “Good night, Papa.” Francesca stepped into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miss?” Her personal maid, Betty, appeared at the far end of the corridor. In her hand was an envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was surprised to see her. “Betty, why didn’t you go to bed? I told you, I do not mind.” She saw no reason for Betty to wait up for her. Other young ladies might be incapable of getting out of their gowns, but she could manage quite easily and hardly needed a servant to help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Betty, who was Francesca’s own age, smiled at her. “Oh, miss, it is so hard to get those buttons opened by yourself! And it’s my work to take care of you. Besides, this come for you, and the cabbie who brought it said it was urgent, miss, terribly so.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("As it was almost midnight, Francesca was intrigued. She took the small envelope, noting its premier quality. It was addressed ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("to her at her Fifth Avenue home, but bore no sender’s name. “A cabdriver brought this?”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca unsealed the envelope and pulled out a small parchment. The note was brief and handwritten.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Francesca, I am in desperate need. Please come to Daisy’s.")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Rose")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA LEANED FORWARD")]), _vm._v(" eagerly in the hansom cab she had hired. Stealing out of the house at the midnight hour had been easily accomplished, with her father still in the library and her mother upstairs and presumably in bed. The doorman, Robert, had pretended not to see her escape—but then, she gave him a weekly gratuity to ensure that he look the other way at such times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After leaving the house, she had walked to the prestigious Metropolitan Club, but a block south of the Cahill home. There, she had merely waited for a gentleman to arrive at the club. Traffic was light, as it was a Monday night, but this was New York City, and eventually a hansom had paused before the club’s imposing entrance to discharge his fare. Not wanting to be recognized, Francesca had bowed her head as a gentleman walked past her, but she knew he stared, as genuine ladies did not travel about the city at such an hour alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca clung to the safety strap, straining to glimpse Daisy Jones’s residence as her cab rumbled toward it. She simply could not imagine what Rose could want.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Daisy Jones was Hart’s ex-mistress, and one of the most beautiful women Francesca had ever seen. When they first met, she had also been one of the city’s most expensive and sought-after prostitutes. Francesca had been on a case at the time, working closely with Calder’s half brother, Rick Bragg, the city’s police ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("commissioner. In fact, at that time she barely knew Hart—and had thought she was in love with Rick.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca had not been surprised when she had learned of the liaison between them. She understood why Hart would want to keep such a woman. In fact, she and Daisy had become rather friendly during that investigation—but any friendship had vanished when Hart had asked Francesca to marry him. Jilted, Daisy had not been pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The large Georgian mansion appeared in her view. Daisy continued to reside in the house Hart had bought for her, as part of a six-month commitment he had promised her and was honoring. Francesca thought, but was not sure, that Rose was now living there, too. Rose was Daisy’s dearest friend—and she had been her lover, before Daisy had left her for Hart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hansom had stopped. Francesca reached for her purse, noting that the entire house was dark, except for the outside light and two upstairs windows. Alarm bells went off in her mind. Even at such a late hour, a few lights should remain on inside on the ground floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca paid the driver, thanking him, and stepped down to the curb. She paused to stare closely at the square brick house as he pulled away. There was no sign of movement, but then, at this hour that was not unusual. Uncertain of what to expect, she pushed open the iron gate and started up the brick path leading to the house. The gardens in front were lush and well tended and Francesca cautiously scanned them. Her nerves were on end, she realized, and she almost expected someone to jump out at her from behind a shrub or bush.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as she was about to silently reassure herself, she noticed that the front door was open.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Francesca halted, fully alert now. Suddenly, she thought about her mad dash from home. She had not bothered to go upstairs to retrieve her gun, a candle or any of the other useful items she ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("habitually kept in her purse. She made a mental note to never leave home without her pistol again.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca glanced inside the house. The front hall was cast in black shadow. She slowly pushed the front door open fully, the hairs on her nape prickling, and stepped in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had a very bad feeling, oh yes. Where was Daisy? Where was Rose? Where were the servants? Francesca moved quietly to the wall, groping for the side table she knew was there. Pressing against it, she strained to listen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had a mouse crept across the floor, she would have heard it, for the house was so achingly silent. She desperately wanted to turn on a gas lamp, but she restrained herself. Francesca waited another moment for her eyes to adjust to the darkness and then she crept forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A dining room was ahead and to her right. Francesca opened the doors, wincing as the hinges groaned, but the large room was dark and vacant. She did not bother to shut the doors but quickly crossed the hall, glancing nervously at the wide, sweeping staircase as she passed it. The closest door was to the smaller of two adjoining salons. Francesca pushed it open. As she had thought, that room also appeared to be empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused, swept back to another time when she had stood in that room, her ear pressed to the door that adjoined the larger salon, spying upon Hart and Daisy. She had barely known Calder, but even then his appeal had been powerful and seductive; even then, she had been drawn to him as a moth to a flame. That day, she had been audacious enough to watch Hart make love to his mistress. Such an intrusion on their privacy was shameful, and Francesca knew it. Still, she had been incapable of stopping herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook the recollection off. That had been months ago, before she had ever been in Hart’s arms, before Hart had cast Daisy aside—before she and Daisy had become enemies and rivals.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("None of that mattered. If Daisy or Rose were in trouble, Francesca intended to help. She left the salon the way she had come in. The moment she stepped back into the hall, she heard a deep, choking sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was not alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca froze. She stared at the wide staircase facing her, straining to hear. The guttural noise came again, and this time, she felt certain it was a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The noise had not come from upstairs, but beyond the staircase, somewhere in the back of the house. Francesca wished she had a weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Throwing all caution to the wind, Francesca rushed past the staircase. “Daisy? Rose?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now she saw a flickering light, as if cast by a candle, coming from a small room just ahead. The door was widely open and she quickly discerned that it was a study, with a vacant desk, a sofa and chair. Francesca rushed to the threshold and cried out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose was sitting on the floor, hunched over a woman whose platinum hair could only belong to Daisy. Rose was moaning, the sounds deep and low and filled with grief.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Surely Daisy was only hurt! Francesca ran forward and saw that Rose held her friend in her arms. Daisy was in a pale satin supper gown, covered with brilliantly, shockingly red blood. Francesca dropped to her knees and finally saw Daisy’s beautiful face—and her wide, blue, sightless eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Daisy was dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose moaned, rocking her again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was in shock. From the look of her dress, Daisy had been murdered, perhaps with a knife. Horror began as she realized the extent of the wounds on Daisy’s chest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Who would want her dead, and why? Francesca recalled the last time she had seen Daisy. She and Rose had appeared at the funeral for Kate Sullivan, a murder victim from Francesca’s ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("most recent investigation. There had been no reason for her to attend, except one: to taunt Francesca. She had been hostile and bitter, and she had clearly wanted Hart back. She had done her best to cause tension between Hart and Francesca, and she had wittingly played upon all of Francesca’s insecurities.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That day, outside of the church, she and Daisy had exchanged harsh words. Although Francesca could not remember the exact conversation, she knew she had been upset and dismayed, precisely as Daisy had planned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But dear God, though Daisy had maliciously done her best to hurt both Francesca and Hart, she had not deserved this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The questions returned. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who would do this—and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca knelt. Rose had not stopped rocking her friend, weeping now in silent grief. Francesca reached out, grasping her arm. “Rose,” she gasped. “I am so sorry!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose froze, slowly looking up. Her green eyes were glazed with misery and tears. She shook her head, unable to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca quickly closed Daisy’s eyes, shivering as she did so. Daisy was impossibly fair, blue-eyed, with platinum hair, her skin the color of alabaster. Delicate and petite, she had a sensuous grace that could only be inherent, never achieved. Now her small bosom was a mass of bloody, gaping flesh. Francesca would never become accustomed to death, and especially not violent death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stood, shaking, and decided against turning on more lights. The murder had been a brutal one. Rose did not need to be confronted with the extent of Daisy’s wounds. Francesca took a soft cashmere throw from the sofa, feeling ill, very much so. She inhaled raggedly for control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will find out who did this,” she whispered, aching for Rose now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose looked up accusingly. “Don’t pretend that you care! We both know you hated her because Hart took care of her. I know you hated her for ever having been in Hart’s bed!”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca, still holding the throw, shook her head. She felt a tear tracking down her cheek. “You’re wrong. I do care. I care very much. Daisy did not deserve this. No one deserves this!” She approached and laid a hand on the brunette’s shoulder. “Please. Leave her now. Come, Rose, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose shook her head, choking, hugging Daisy more tightly. She was as dark, voluptuous and tall as Daisy was fair, slender and petite. Now she was covered with her friend’s blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need to go to the police,” Francesca said, thinking of Rick Bragg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca needed him now. They made an excellent team—they had solved a half a dozen dangerous and difficult cases together, and he remained her good friend. It was late, but he had to be summoned immediately. Together they would find Daisy’s killer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart’s dark, smoldering image came to mind. He might not have ever loved Daisy, but how would he react to the news of her murder? Francesca realized she would be the one to tell him of the death of his former mistress, and un fortunately, she would have to do so the moment he returned home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The police?” Rose’s voice was scathing and bitter. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We")]), _vm._v(" need to find Daisy’s murderer! I am hiring you, to find the killer, Francesca. Forget those leatherheads! They won’t give a damn about Daisy,” she said, and she began to weep all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca nodded, but her instincts warned her not to take on Rose as a client. She took the opportunity to kneel and cover Daisy’s brutally disfigured body with the throw, then somehow she pulled Rose to her feet, putting her arm around her. “Please, come sit down in the salon,” she said, wanting very much to get Rose out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Rose balked. “No. I am not leaving her alone like this!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Francesca quickly knelt and pulled the throw over Daisy’s face. “I do need to get the police. There has been a murder, and ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("they must be notified. But I don’t want to leave you here alone, Rose.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose sat abruptly on the sofa, her face collapsing into tears again. “Who would do this? And why? Oh, God why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca sat besides her, her mind beginning to function fully again. She had received Rose’s note a good half an hour ago, a few moments before midnight. Betty had said the note had been dropped off at the house just a few minutes before they arrived home. The trip uptown from Daisy’s house was thirty minutes in light traffic, so Rose had sent the note around eleven-thirty. “Rose? Can you answer a few questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose looked up. “Are you going to find her killer? The police won’t care. I don’t trust those flies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca hesitated, recalling Daisy’s hostility the last time they had spoken, and Rose’s own hatred of Hart for taking Daisy away from her. But how could she refuse Rose, who had loved Daisy so? “Yes. Yes, Rose, I will take the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You will take the case, even though you hated her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t hate her, Rose. I was afraid of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose jerked, meeting Francesca’s gaze. Slowly, she said, “All right. What do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What happened here tonight? When did you find her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose swallowed. “I don’t know. I was out for the evening. When I got here, the house was dark, I knew some thing was wrong! I called for her, but she didn’t answer.” Rose stopped, for out in the hall, a soft bump had sounded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stiffening, Francesca looked at the open door, as did Rose. The hall beyond was lost in shadow and she saw nothing. But she had heard a noise—someone was present.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca stood. “Where are the servants?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The butler sleeps in his room behind the kitchens, as does the maid. The housekeeper goes home at five.” Rose was ashen and wide-eyed now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you go below stairs when you came home?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose shook her head. “No. I was about to go upstairs when I saw the light coming from this room.” Her mouth trembled and she glanced at Daisy’s covered body. She inhaled, clearly fighting more tears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait here,” Francesca said. She glanced at the desk, saw a letter opener and took it. Then she changed her mind, putting it back and taking a crystal paperweight instead. After what had been done to Daisy, she did not think she could stab anyone. Clutching the paperweight, she left the study. The corridor outside remained dark and every blond hair on her nape prickled with dread and fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someone was lurking in the corridor leading to the kitchen and servants’ quarters. But it would make little sense for that someone to be the killer, who must have long since fled. It was probably just a servant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the other hand, murderers often defied every possible assumption one might make about them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca took a deep breath for courage, once more wishing she had her gun, and she started forward, trying to make as little noise as possible. She heard footsteps approaching—each footfall slow and cautious. She froze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her grip on the paperweight tightened. She debated turning to flee, but in a moment whoever was beyond her would appear and see her. Instead, she pressed against the wall, waiting. The shadowy form of a man appeared, carrying a candle. He saw her against the wall, halted in midstride and lifted the candle higher.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was illuminated—but so was he.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Standing there in the hall was her fiancé.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7551d871","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426884405_ch01.vue
// module id = 72
// module chunks = 0